import React, { useMemo } from 'react';
import { View, Image } from 'react-native';
import { createOrganizationLogoStyles } from '../../shared/theme/styles/logo';
import { appTheme, useThemeColors } from '../../shared/theme';

export interface OrganizationLogoProps {
  logoUri: string | null;
}

export function OrganizationLogo({ logoUri }: OrganizationLogoProps): React.ReactElement {
  const colors = useThemeColors() ?? appTheme.colors;
  const styles = useMemo(() => createOrganizationLogoStyles(colors), [colors]);
  return (
    <View style={styles.logoCard}>
      {logoUri ? <Image source={{ uri: logoUri }} style={styles.logoImage} resizeMode="contain" /> : <View style={styles.logoPlaceholder} />}
    </View>
  );
}
